import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import type { TaskGroupNode } from './rete/task-group-node';

@customElement('kv-task-group')
export class KvTaskGroup extends LitElement {
  static styles = css`
    :host {
      position: absolute;
      inset: 0;
      box-sizing: border-box;
      border: 1px dashed rgba(104, 196, 255, 0.7);
      border-radius: 12px;
      background: rgba(104, 196, 255, 0.06);
      backdrop-filter: blur(2px);
      z-index: 0;
      pointer-events: none;
    }
    :host([visible]) .center-label {
      display: none;
    }
    :host(.selected) {
      outline: none;
      box-shadow:
        0 0 0 1px var(--color-node-selected-outline1),
        0 0 0 3px var(--color-node-selected-outline2);
      border-color: var(--color-node-hover-border);
    }
    .label {
      position: absolute;
      top: -14px;
      left: 8px;
      padding: 2px 8px;
      background: rgba(12, 18, 28, 0.92);
      color: #cfe8ff;
      font-size: 12px;
      border-radius: 8px;
      border: 1px solid rgba(104, 196, 255, 0.6);
      white-space: nowrap;
      pointer-events: auto;
      z-index: 2;
    }
    .center-label {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      font-weight: 700;
      color: #cfe8ff;
      text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
      pointer-events: auto;
      letter-spacing: 0.5px;
      z-index: 2;
    }
    :host([content-visible]) .center-label {
      display: none;
    }
  `;

  declare data: TaskGroupNode;
  static get properties() {
    return {
      data: { type: Object },
    };
  }

  render() {
    this.style.width = `${this.data.width}px`;
    this.style.height = `${this.data.height}px`;
    if (this.data.selected) {
      this.classList.add('selected');
    } else {
      this.classList.remove('selected');
    }

    const label =
      this.data.taskCount > 0
        ? `${this.data.title ?? 'Group'} (${this.data.taskCount})`
        : (this.data.title ?? 'Group');
    const contentVisible = (this.data as any).contentVisible;
    this.toggleAttribute('content-visible', !!contentVisible);
    return html`
      <div class="label">${label}</div><div class="center-label">${label}</div>
    `;
  }
}
